export const clearLocalStorageExcept = (keysToKeep) => {
    const preserved = {};
    
    // Save items we want to keep
    keysToKeep.forEach(key => {
      preserved[key] = localStorage.getItem(key);
    });
    
    // Clear everything
    localStorage.clear();
    
    // Restore preserved items
    Object.entries(preserved).forEach(([key, value]) => {
      if (value) {
        localStorage.setItem(key, value);
      }
    });
  };